import { render } from "./DiscoveryToolMapsPage.vue?vue&type=template&id=c8ff741a"
import script from "./DiscoveryToolMapsPage.vue?vue&type=script&lang=js"
export * from "./DiscoveryToolMapsPage.vue?vue&type=script&lang=js"

import "./DiscoveryToolMapsPage.vue?vue&type=style&index=0&id=c8ff741a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__